import type { ReactNode, JSX} from "react";
import { Avatar } from "./Avatar";
import type { AvatarProps } from "./Avatar";
import { Row } from "./Row";
import { TopBarHeader } from "./TopBarHeader";
import { TOPBAR_AVATAR_SIZE } from "./topBarTokens";

export interface PersonHeaderProps {
  readonly name: string;
  readonly statusText?: string;
  readonly initials: string;
  readonly color?: AvatarProps["color"];
  readonly avatarSize?: AvatarProps["size"];
  readonly avatar?: ReactNode;
  readonly actions?: ReactNode;
  readonly showStatusDot?: boolean;
  readonly className?: string;
}

/**
 * Header showing a person with avatar, name, status, and action buttons.
 * Used in inbox, contacts, meetings, and email detail headers.
 */
export function PersonHeader({
  name,
  statusText,
  initials,
  color = "orange",
  avatarSize = TOPBAR_AVATAR_SIZE,
  avatar,
  actions,
  showStatusDot = true,
  className,
}: PersonHeaderProps): JSX.Element {
  const subtitle = statusText ? (
    <Row gap={1.5} align="center">
      {showStatusDot && (
        <span className="w-[7px] h-[7px] rounded-full bg-green inline-block" />
      )}
      <span className="truncate text-inherit">{statusText}</span>
    </Row>
  ) : undefined;

  return (
    <TopBarHeader
      leading={avatar ?? <Avatar label={initials} color={color} size={avatarSize} />}
      title={name}
      subtitle={subtitle}
      actions={actions}
      className={className}
    />
  );
}
